import React from 'react';
import s from './s.module.less';
import { Button } from 'antd';
import Image1 from './images/1.png';

interface IProps {
    setFirstLoginPopupStep: (step: number) => void;
    onClosePopup: () => void;
}

const Modal1 = ({
    setFirstLoginPopupStep,
    onClosePopup,
}: IProps) => {
    return (
        <div className={s.wrap}>
            <div className={s.playerBox}>
                <div className={s.closeIcon} onClick={onClosePopup} />
                <div className={s.player}>
                    <img src={Image1} alt="" />
                </div>
            </div>
            <div className={s.content}>
                <div className={`${s.title}`}>Getting new clients from Kiwi Health is simple</div>
                <div className={s.desc}>With our Klarity’s Pay-for-Appointment model, you only pay when patients book—no subscriptions, no setup hassle. You’re also protected from no-shows and late cancellations. 92% of providers choose this model over Zocdoc, SEO, or ads.</div>
            </div>
            <div className={s.footer}>
                <div className={s.btns}>
                    <Button type="primary" onClick={() => setFirstLoginPopupStep(2)}>Next</Button>
                </div>
            </div>
        </div>
    );
};

export default Modal1;
